//import EventPicker from './EventPicker';
import EventByTeamPicker from './EventByTeamPicker';
import EventByDatePicker from './EventByDatePicker';
import TournamentPicker from './TournamentPicker';
import Switcher from './Switcher';
import Checkboxes from './Checkboxes';
import RoundPicker from './RoundPicker';
import TeamPicker from './TeamPicker';
import ThemePicker from './ThemePicker';
import TemplatePicker from './TemplatePicker';
import WidgetHeaderPicker from './WidgetHeaderPicker';
import MoreButtonPicker from './MoreButtonPicker';
import TextFieldPicker from './TextFieldPicker';
import TextAreaPicker from './TextAreaPicker';
import SelectPicker from './SelectPicker';
import PlayerPicker from './PlayerPicker';
import EnumPicker from './EnumPicker';
import PlayerComparisonPicker from './PlayerComparisonPicker';
import PlayersComparisonPicker from './PlayersComparisonPicker';

import TeamPlayerPicker from './TeamPlayerPicker';
import TournamentPickerMulti from './TournamentPickerMulti';
import LiveListTournamentsPicker from './LiveListTournamentsPicker';
import DatePicker from './DatePicker';
import TeamTournamentsPicker from './TeamTournamentsPicker';
import StagePicker from './StagePicker';
import StagePickerOneCheck from './StagePickerOneCheck';
import IncidentPicker from './IncidentPicker';
import Slider from './Slider';
import PreviewImagePicker from './PreviewImagePicker';
import TransferPicker from './TransferPicker';
import SportByDatePicker from './SportByDatePicker';
import F1GrandPrixPicker from './F1GrandPrixPicker';
import OddsPicker from './OddsPicker';
import OddsProviderPicker from './OddsProviderPicker';
import MultipleBackgroundsPicker from './MultipleBackgroundsPicker';
import DNDBgrPicker from './DNDBgrPicker';

import OverlayStyler from './OverlayStyler';

const pickers = {
    team_picker: TeamPicker,
    event_picker: TextFieldPicker,
    event_by_team_picker: EventByTeamPicker,
    event_by_date_picker: EventByDatePicker,
    tournament_picker: TournamentPicker,
    tournament_picker_multi: TournamentPickerMulti,
    round_picker: RoundPicker,
    boolean: Switcher,
    checkboxes: Checkboxes,
    textfield_picker: TextFieldPicker,
    textarea_picker: TextAreaPicker,
    more_button_picker: MoreButtonPicker,
    select_picker: SelectPicker,
    theme_picker: ThemePicker,
    template_picker: TemplatePicker,
    player_picker: PlayerPicker,
    widget_header_picker: WidgetHeaderPicker,
    enum_picker: EnumPicker,
    player_comparison_picker: PlayerComparisonPicker,
    players_comparison_picker: PlayersComparisonPicker,
    team_player_picker: TeamPlayerPicker,
    date_picker: DatePicker,
    team_tournaments_picker: TeamTournamentsPicker,
    stage_picker: StagePickerOneCheck,
    stages_picker: StagePicker,
    incident_picker: IncidentPicker,
    overlay_styler: OverlayStyler,
    live_list_tournaments_picker: LiveListTournamentsPicker,
    slider: Slider,
    preview_image: PreviewImagePicker,
    transfer_picker: TransferPicker,
    sport_by_date_picker: SportByDatePicker,
    f1_grand_prix_picker: F1GrandPrixPicker,
    odds_picker: OddsPicker,
    odds_provider_picker: OddsProviderPicker,
    multiple_backgrounds_picker: MultipleBackgroundsPicker,
    dnd_bgr_picker: DNDBgrPicker
};

export default pickers;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/index.js
 **/